import { useState } from "react";

const baseURL = window.location.origin;

export default function PayLinkAgentOrderCopyButton({ item }) {
  const [copied, setCopied] = useState(0);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(
        `${baseURL}/payLink?id=${item.numberParcel}`
      );
      setCopied(1);
    } catch (er) {
      setCopied(2);
    }

    setTimeout(() => setCopied(0), 1000);
  };

  return (
    <button
      className="btn btn-outline-secondary text-center"
      onClick={copyToClipboard}
      style={{ width: 142 }}
    >
      {copied === 0 && "کپی لینک پرداخت"}
      {copied === 1 && "کپی شد !"}
      {copied === 2 && "خطا در کپی !"}
    </button>
  );
}
